import type {
  InstallationOptionCardSchema,
  InstallationOptionsSectionSchema
} from '@ecomm/home-landing-data'

const sideMock: InstallationOptionCardSchema = {
  content: [
    {
      __typename: 'ContentfulSmallText',
      text: {
        raw: '{"data":{},"content":[{"data":{},"content":[{"data":{},"marks":[],"value":"Set it up yourself","nodeType":"text"}],"nodeType":"heading-3"},{"data":{},"content":[{"data":{},"marks":[],"value":"Your SimpliSafe system was designed to work right out of the box. Just plug in your Base Station and follow the interactive instructions in the app to place sensors and set up monitoring. From there, you’ll be protected 24/7.","nodeType":"text"}],"nodeType":"paragraph"}],"nodeType":"document"}'
      },
      icon: {
        url: '/main-image',
        description:
          'A pair of hands holding a SimpliSafe Box with the 9-piece kit on it',
        originalWidth: 636,
        originalHeight: 512
      }
    },
    {
      __typename: 'ContentfulImageAndText',
      text: {
        raw: '{"data":{},"content":[{"data":{},"content":[{"data":{},"marks":[],"value":"Easy set up in minutes with interactive guidance from the SimpliSafe App","nodeType":"text"}],"nodeType":"paragraph"}],"nodeType":"document"}'
      },
      image: {
        url: '/image-icon',
        description: 'Easy to set up icon',
        originalWidth: 61,
        originalHeight: 74
      }
    }
  ]
}

export const installationOptionsSectionMock: InstallationOptionsSectionSchema =
  {
    __typename: 'ContentfulTwoColumnSection',
    leftSide: sideMock,
    rightSide: sideMock
  }

export const wrongMock = {
  __typename: 'ContentfulTwoColumnSection',
  leftSide: sideMock,
  rightSide: {
    content: [
      {
        __typename: 'WrongType'
      }
    ]
  }
}
